import React from 'react';

const SvgCheckMarkIcon = (props) => (
  <svg
    viewBox="0 0 10 10"
    width="1em"
    height="1em"
    {...props}
    id="CheckMarkIcon">
    <path
      d="M5 .1C2.3.1.1 2.3.1 5S2.3 9.9 5 9.9 9.9 7.7 9.9 5 7.7.1 5 .1zM3.87 8.48L.66 5.27 1.73 4.2l2.19 2.19 4.26-4.26L9.2 3.15 3.87 8.48z"
      fill="currentColor"
    />
  </svg>
);

export default SvgCheckMarkIcon;
